export default "__VITE_PUBLIC_ASSET__1ffeb05e__"